function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOpenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.72,12.16c-.78-1.15-2.59-2.09-3.88-3-5.9-4.24-3.93-3.84-11.74,1.45-.86.54-2.22,1.58-2.37,2.8a2.51,2.51,0,0,0,.37,1.36,1.29,1.29,0,0,0,1.07.66h1.3V10.91a.38.38,0,0,1,.36-.38H22.19a.38.38,0,0,1,.38.38V15.4h.35c.87,0,1.38.07,1.94-.57A2.27,2.27,0,0,0,24.72,12.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.93,16.6l-.73.54v.91L16,22.81,8.77,18.05v-.93l-.68-.52a14.2,14.2,0,0,1-1.35-1.11V22.7a8.92,8.92,0,0,0,.07,1.37,1.64,1.64,0,0,0,1.65,1.29H23.52a1.66,1.66,0,0,0,1.66-1.29,10.4,10.4,0,0,0,.1-1.37V15.5C25,15.75,24.52,16.15,23.93,16.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,21.93l6.11-4V11.38a.35.35,0,0,0-.34-.36H10.22a.35.35,0,0,0-.35.35h0V17.9ZM13.22,13.5h5.51a.54.54,0,0,1,0,1.08H13.22a.54.54,0,1,1,0-1.08Zm-.54,3.25h0a.56.56,0,0,1,.48-.57H18.8a.55.55,0,0,1,.47.54h0a.55.55,0,0,1-.53.54H13.22a.54.54,0,0,1-.54-.54h0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpenWhite);
export default __webpack_public_path__ + "static/media/email-open-white.637b028a.svg";
export { ForwardRef as ReactComponent };